/**
 * Global registry of active AbortControllers.
 * Scenario fixed:  operator click on "Revenir à mon compte" button, as cart load request is in-progress, even existing operator view it load product screen.
 * 
 * Usage:
 *   // Before starting a fetch:
 *   const controller = new AbortController();
 *   const unregister = registerController(controller);
 *   fetch(url, { signal: controller.signal })
 *     .finally(unregister);
 *
 *   // To cancel everything (e.g. "Revenir à mon compte"):
 *   abortAll();
 */

const _registry = new Set();

/**
 * Register an AbortController.
 * Returns an `unregister` function to call when the request completes.
 */
export function registerController(controller) {
    _registry.add(controller);
    return () => _registry.delete(controller);
}

/**
 * Abort every registered controller and clear the registry.
 * Safe to call even when the registry is empty.
 */
export function abortAll() {
    _registry.forEach((controller) => {
        try {
            controller.abort();
        } catch (_) { }
    });
    _registry.clear();
}
